import { useQuery } from '@tanstack/react-query';
import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { QueryKey } from '@/config/query-client';
import { projectIdState } from '../../project.state';
import { fetchProjectExternalLinks } from '@/api/v4/project-external-links.api';
import { useAtomValue } from 'jotai';

export const useProjectExternalLinks = () => {
  const projectId = useAtomValue(projectIdState);

  const getProjectExternalLinks = async () => {
    if (!projectId) {
      return [];
    }

    return await fetchProjectExternalLinks(projectId);
  };

  return useQuery({
    queryKey: [QueryKey.ProjectExternalLinks, projectId],
    queryFn: getProjectExternalLinks,
    staleTime: getTimeInMs(5, 'minute'),
    gcTime: getTimeInMs(5, 'minute'),
  });
};
